import { callApiWithAuthorization } from "../CallApi";

export async function getAttributes(entityId) {
    const request = await callApiWithAuthorization("/api/v0/attributes/" + entityId);
    const response = await request.json();
    return response;
}

export async function createAttribute(entityId, properties) {
    const request = await callApiWithAuthorization("/api/v0/entity/" + entityId + "/attribute", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    });
    const response = await request.json();
    return response;
}

export async function updateAttribute(id, properties) {
    const request = await callApiWithAuthorization("/api/v0/attribute/" + id, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    })
    const response = await request.json();
    return response;
}

export async function deleteAttribute(entityId, attributeId) {
    const request = await callApiWithAuthorization("/api/v0/entity/" + entityId + "/attribute/" + attributeId, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json"
        }
    })
    const response = await request.json();
    return response;
}

export async function bulkDeleteAttributes(entityId, attributeIds) {
    const request = await callApiWithAuthorization('/api/v0/attribute/BulkDelete', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            entityId: entityId,
            attributeIds: attributeIds,
        })
    })
    const response = await request.json();
    return response;
}

export async function findEntityAttributeReferencesInFormulas({ entityId, entityName }) {
    const request = await callApiWithAuthorization(`/api/v0/entity/${entityId}/formula-references`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ entityName })
    })
    const response = await request.json();
    return response;
}

export async function findFormulaReferencesForAttribute({ entityId, entityName, attributeId }) {
    const request = await callApiWithAuthorization(`/api/v0/entity/${entityId}/attribute/${attributeId}/formula-references`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ entityName })
    });
    const response = await request.json();
    return response;
}

export async function updateAllAttributeFormulaOnEntityNameChange({ entityId, oldEntityName, newEntityName }) {
    const request = await callApiWithAuthorization("/api/v0/entity/" + entityId + "/formulas", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ oldEntityName, newEntityName })
    })
    const response = await request.json();
    return response;
}

export async function toggleAttributeRequiredInAlice(entityId) {
    const request = await callApiWithAuthorization("/api/v0/entity/" + entityId + "/attributes/toggleRequiredInAlice", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
    })
    const response = await request.json();
    return response;
}

export async function saveStatesForAttribute(data) {
    const request = await callApiWithAuthorization(`/api/v0/attribute/saveStatesForAttribute`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    const response = await request.json();
    return response;
}

export async function saveRulesForStateFieldAttribute(data) {
    const request = await callApiWithAuthorization(`/api/v0/attribute/saveRulesForStateFieldAttribute`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    const response = await request.json();
    return response;
}

export async function saveStatesForAttributeTemplate(data) {
    const request = await callApiWithAuthorization(`/api/v0/attribute/saveStatesForAttributeTemplate`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    const response = await request.json();
    return response;
}

export async function getStatesForAttributeTemplate(attributeTemplateId) {
    const request = await callApiWithAuthorization(`/api/v0/attribute/${attributeTemplateId}/getStatesForAttributeTemplate`)
    const response = await request.json();
    return response;
}


export async function updateAttributeNode(id, properties) {
    const request = await callApiWithAuthorization("/api/v0/attribute/" + id, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    })
    const response = await request.json();
    return response;
}

export async function updateAttributeFormula({
    entityId,
    attributeId,
    formula,
    formulaJson,
    triggerSetting
}) {
    const request = await callApiWithAuthorization(
        `/api/v0/attribute/${attributeId}/formula`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                entityId,
                formula,
                formulaJson,
                triggerSetting
            })
        }
    );
    const response = await request.json();
    return response;
}

export async function unlinkPicklistAttribute(attributeId) {
    const request = await callApiWithAuthorization(
        `/api/v0/attribute/${attributeId}/unlink-from-progress-bar`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({})
        }
    );
    const response = await request.json();
    return response;
}

export async function getEntityLookupReferencedAttribute(entityLookupId) {
    const request = await callApiWithAuthorization(
        `/api/v0/attribute/${entityLookupId}/referenced-attribute`
    );
    const response = await request.json();
    return response;
}

export async function getIsStartOrEndAttributeInGanttChart(attributeId) {
    const request = await callApiWithAuthorization(
        `/api/v0/attribute/${attributeId}/is-start-or-end-attribute-in-gantt-chart`
    );
    const response = await request.json();
    return response;
}